import { useState, forwardRef } from "react";
import { EyeIcon, EyeCloseIcon } from "@/components/icons";
import { Input } from "@hipotecar/ui/input";
import { cn } from "@hipotecar/ui/lib/utils";
import type { ComponentProps } from "react";

interface PasswordInputProps extends Omit<
	ComponentProps<typeof Input>,
	"type"
> {
	showToggle?: boolean;
}

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
	({ className, showToggle = true, ...props }, ref) => {
		const [showPassword, setShowPassword] = useState(false);

		const handleToggle = (e: React.MouseEvent) => {
			e.preventDefault();
			e.stopPropagation();
			setShowPassword(!showPassword);
		};

		return (
			<div className="relative">
				<Input
					type={showPassword ? "text" : "password"}
					className={cn(showToggle && "pr-10", className)}
					ref={ref}
					{...props}
				/>
				{showToggle && (
					<button
						type="button"
						onMouseDown={handleToggle}
						className="absolute top-1/2 right-0 -translate-y-1/2 px-3 text-gray-800 hover:text-gray-900 focus:outline-hidden dark:text-gray-100 dark:hover:text-white"
						tabIndex={-1}
						aria-label={showPassword ? "Hide password" : "Show password"}
					>
						{showPassword ? (
							<EyeIcon className="size-5 fill-current" />
						) : (
							<EyeCloseIcon className="size-5 fill-current" />
						)}
					</button>
				)}
			</div>
		);
	},
);

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
